import cookies from './cookies';
const auth = () => {
  if (cookies.get('login')) {
    return true;
  } else {
    return false;
  }
};
export default auth;